const prefix = '/visitor/v2'

export default {
  /** 查询主办人员列表 */
  organizerLinkList: prefix + "/organizerLink/getList",
  /** 开关/配置项/数据项列表 */
  getConfigurationInformation: prefix + "/configurationItem/visitor/getConfigurationInformation",
  /** 获取展会列表 */
  exhibitionList: prefix + "/exhibitorReserveExhibition/getListByExhibitionId",
  /** 获取国家 */
  countryList: prefix + "/area/getCountryList",
  /** 获取省份 */
  provinceList: prefix + "/area/getProvinceList",
  /** 获取城市 */
  cityList: prefix + "/area/getCityList",
  /** 提交报名信息 */
  exhibitorInsert: prefix + "/exhibitorReserve/insert",
  /** 提交报名信息-观众 */
  visitorInsert: prefix + "/visitorReserve/insert",
  /** ccbn获取微信授权签名 */
  wxConfig: 'https://api.eastfair.com/wechat/client/signature',
  /** 查询预约报名展会信息 */
  exhibitorReserveExhibition: prefix + "/exhibitorReserve/getExhibitionReserveInfo",
  /** 查询预约报名展会信息-观众 */
  exhibitorReserveVisitor: prefix + "/visitorReserve/getBackData",
  /** 查询直播详情 */
  liveDetail: prefix + "/live/queryDetail",
  /** 根据token获取身份 */
  getSubjectTypeByToken: prefix + "/account/getSubjectTypeByToken",
  /** 获取演讲嘉宾列表 */
  getGuest: prefix + "/guest/select",
  /** 获取一个展商的商品列表 */
  queryProductList: prefix + "/product/productList",
  /** 获取海报模版列表 */
  getTemplateList: prefix + "/poster/getTemplateList",
  /** 创建海报 */
  addPoster: prefix + "/poster/addPoster",
  /** 获取我的海报列表 */
  getPosterPage: prefix + "/poster/getPosterPage",
  /** 海报删除 */
  delPoster: prefix + "/poster/delPoster",
  /** 获取海报详情 */
  getPosterDetail: prefix + "/poster/getPoster",
  /** 修改海报名称 */
  updatePoster: prefix + "/poster/updatePoster",
  /** 获取展商基本信息 */
  getExhibitorBaseInfo: prefix + "/exhibitor/getExhibitorBaseInfo",
  /** 图片上传 */
  uploadImageByBaseStr: prefix + "/uploadImageByBaseStr",
  /** 获取小程序二维码 */
  getACodeUnLimit: prefix + "/externalInterface/wx/getACodeUnLimit",
  /** 二维码参数保存接口 */
  saveParam: prefix + "/externalInterface/param/saveParam",
  /** 直播测试地址 */
  live: prefix + "/live/queryDetail",
  // 查询会议接口
  meetingGet: prefix + "/meeting/get",
  // 会议列表
  meetingList: prefix + "meeting/listPersonByMeetingId",
  // 卡券详情
  getCard: prefix + "/giftCard/getCard",
  // 数字金融
  getFigures: prefix + '/configurationItem/visitor/getConfigurationItemList',
  // 新闻详情
  getNewsDetail: prefix + '/article/getArticle',
  // 金融-资讯类型-红点已读
  readBannerNews: prefix + '/configurationItem/visitor/readBannerNews',
  // 获取展会信息
  getExhibition: prefix + '/exhibition/getExhibition',
  // 获取展商详情
  getExhibitorDetails: prefix + '/exhibitor/visitor/exhibitorDetails',
  // 邀约
  invite: prefix + '/appointment/invite',
  // 获取coze授权
  getCozeJwtToken: prefix + '/coze/getCozeJwtToken',
  // 员工列表
  getExhibitorEmployeeList: prefix + '/exhibitorEmployee/visitor/getExhibitorEmployeeList',
  // 发送邀约
  newAddInviteRecrd: prefix + '/inviteRecord/newAddInviteRecrd',
  // 展商-邀约列表-待确认
  inviteRecordList: prefix + '/PcInviteRecord/inviteRecordList',
  // 展商-邀约列表-已确认
  contactPersonList: prefix + '/PcContactPerson/contactPersonList',
  // 展商-邀约-确认
  newConfirmInviteRecord: prefix + '/inviteRecord/newConfirmInviteRecord',
  // 获取客户池数量
  getNum: prefix + '/PcContactPerson/getNum',
  // 删除员工（客户池）
  deleteContactPerson: prefix + '/contactPerson/deleteContactPerson',
  // 分配员工-列表
  getEmployeeList: prefix + '/intention/getEmployeeList',
  // 分配员工-分配
  distributionEmployee: prefix + '/contactPerson/distributionEmployee',
  // 观众-邀约展商-已确认
  newContactPersonList: prefix + '/contactPerson/newContactPersonList',
  // 观众-邀约展商-待确认
  inviteRecordListVisitor: prefix + '/inviteRecord/inviteRecordList'
}
